// app/javascript/controllers/index.js
import { application } from "./application"

import CartController from "./cart_controller"
import FadeInController from "./fade_in_controller"
import LanguageSwitcherController from "./language_switcher_controller"; // Ensure this import path is correct
import GalleryController from "./gallery_controller"
import HeroLayoutController from "./hero_layout_controller"
import AutoDismissController from "./auto_dismiss_controller"
import FileInputController from "./file_input_controller"
import SearchController from "./search_controller"
import AppearController from "./appear_controller"
import ChatWidgetController from "./chat_widget_controller"

application.register("cart", CartController)
application.register("fade-in", FadeInController)
// This is the crucial line that needs to be correct:
application.register("language-switcher", LanguageSwitcherController)
application.register("gallery", GalleryController)
application.register("hero-layout", HeroLayoutController)
application.register("auto-dismiss", AutoDismissController)
application.register("file-input", FileInputController)
application.register("search", SearchController)
application.register("appear", AppearController)
application.register("chat-widget", ChatWidgetController)
